module.exports = __webpack_public_path__ + "img/39.f327a6f0.jpg";